import React from "react";
import { Avatar } from 'primereact/avatar';
//http://anderworx.com/wp-content/uploads/2018/09/cropped-Avatar-Round.png
//https://www.clipartmax.com/png/small/257-2572603_user-man-social-avatar-profile-icon-man-avatar-in-circle.png
const ProAvatar = ()=>{
    return  <Avatar image="https://www.clipartmax.com/png/small/257-2572603_user-man-social-avatar-profile-icon-man-avatar-in-circle.png" className="mr-2" shape="circle" >
           
         </Avatar>
   
}

export default ProAvatar;